import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ScannerTrialInfoImages } from "./ScannerTrialInfoImages.component";
import {ScannerTrialInfoImagesMobile} from "../ScannerTrialInfoImagesMobile/ScannerTrialInfoImagesMobile.component";




export function showScannerTrialInfoImagesModal(modalService: NgbModal, mobileMode: string = 'desktop', trueinfo:boolean = false) {
    const mobile = mobileMode != 'desktop';
    const component = mobile? ScannerTrialInfoImagesMobile: ScannerTrialInfoImages;
    const windowClass = "dark-modal largeWindow" + (mobile? ' mobile': '');
    let m: NgbModalRef = modalService.open(component, {
        backdrop: "static",
        size: "lg",
        centered: true,
        windowClass: windowClass
    });
    let modal = (<ScannerTrialInfoImages>m.componentInstance);
    modal.trueinfo = trueinfo;
    return modal;
}
